<template>
  <div class="pa-story-chapter-list">
    <button class="pa-story-list-button pa-story-list-button-prev">▲</button>
    
    <div class="story-chapter-list">
      <swiper :options="swiperOptions" ref="storyChapterSwiper">
        <swiper-slide v-for="(chapter, index) in chapterList" :key="index">
          <StoryChapterBanner
           :chapterData="chapter"
           @selectChapter="handleClickChapterBanner"
          />
        </swiper-slide>
      </swiper>
    </div>
    
    <button class="pa-story-list-button pa-story-list-button-next">▼</button>
  </div>
</template>

<script>
import StoryChapterBanner from '@/components/Pages/Home/PAStoryListWidget/StoryChapterBanner/StoryChapterBanner.vue'

export default {
  props : {
    chapterList : {
      default : () => {
        return [];
      }
    }
  },

  components : {
    StoryChapterBanner
  },

  data(){
    return {
      isMountedPage : false,

      swiperOptions : {
        init          : false,
        direction     : 'vertical',
        slidesPerView : 3,
        loop          : false,
        speed         : 800,
        pagination    : false,
        navigation    : {
          prevEl: '.pa-story-chapter-list .pa-story-list-button-prev',
          nextEl: '.pa-story-chapter-list .pa-story-list-button-next'
        }
      }
    };
  },

  computed : {
    swiper(){
      return this.$refs.storyChapterSwiper.$swiper;
    },

    couldInitializeSwiper(){
      if(
        (typeof this.chapterList !== 'undefined') &&
        (this.isMountedPage === true)
      ){
        return true;
      }else{
        return false;
      }
    }
  },

  watch : {
    couldInitializeSwiper : {
      handler(value){
        if(value === false) return;

        this.swiper.init();
      }
    }
  },

  methods : {
    handleClickChapterBanner(chapterData){
      this.$emit('selectChapter', chapterData);
    }
  },

  mounted(){
    this.$parent.$parent.$on('mountedPage', () => {
      this.isMountedPage = true;
    });
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-story-chapter-list{
  .pa-story-list-button{
    box-sizing: border-box;
    display: block;
    width:94%;
    margin:.3rem auto 0;
    border:3px solid #ccb291;
    background-color: #c5ac8c;
    border-radius: 4px;
    text-align:center;
    font-size:1.2rem;
    user-select: none;
    color: #726047;

    &.swiper-button-disabled{
      color: #b9a283;
    }

    :active{
      color: #6c5638;
    }

    @media screen and (min-width: $desktop) {
      width:95%;
      margin:12px auto 0;
    }
  }

  .story-chapter-list{
    width:95%;
    min-height: 100%;
    height:calc(75px * 3);
    margin:0 auto;
    position: relative;
    overflow: hidden;

    @include from($tablet) {
      height:calc(123px * 3);

      .swiper-slide {
        height: auto !important;
      }
    }

    .swiper-container{
      &-vertical{
        min-height:100%;
      }
    }
  }
}
</style>